const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_336",
  "data-name": "Group 336",
  transform: "translate(-155 -167)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_149",
  "data-name": "Rectangle 149",
  width: 56,
  height: 56,
  rx: 10,
  transform: "translate(155 167)",
  fill: "#f0ac02"
}), /*#__PURE__*/React.createElement("g", {
  id: "user-fill",
  transform: "translate(171 183)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_623",
  "data-name": "Path 623",
  d: "M0,0H24V24H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_624",
  "data-name": "Path 624",
  d: "M4,22a8,8,0,0,1,16,0Zm8-9a6,6,0,1,1,6-6A6,6,0,0,1,12,13Z",
  fill: "#fff"
})));
function SvgUserCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCardIcon);
export default __webpack_public_path__ + "static/media/userCardIcon.b839dc7ec6a074283106e39ccb05d426.svg";
export { ForwardRef as ReactComponent };